export default [
  {
    path: '/auth',
    name: 'auth.index',
    meta: {
      layout: 'blank',
      requires: {
        user: false,
        project: false,
      },
      requireProject: false,
    },
    component: () => import('./AuthIndex.vue'),
    children: [
      {
        path: 'setup',
        name: 'auth.setup',
        meta: {
          layout: 'blank',
          requires: {
            user: false,
            project: false,
          },
          requireProject: false,
        },
        component: () => import('./AuthSetupPage.vue'),
      },
      {
        path: 'setup/factory',
        name: 'auth.setup.factory',
        meta: {
          layout: 'blank',
          requires: {
            user: false,
            project: false,
          },
          requireProject: false,
        },
        component: () => import('./AuthFactoryPage.vue'),
      },
      {
        path: 'setup/factory/:projectId/devices',
        name: 'auth.setup.factory.devices',
        meta: {
          layout: 'blank',
          requires: {
            user: false,
            project: false,
          },
          requireProject: false,
        },
        component: () => import('./AuthDevicePage.vue'),
      },
      {
        path: ':code',
        name: 'auth.code',
        meta: {
          layout: 'blank',
          requires: {
            user: false,
            project: false,
          },
          requireProject: false,
        },
        component: () => import('./AuthPage.vue'),
      },
    ],
  },
];
